import { render, staticRenderFns } from "./AdvisorMain.vue?vue&type=template&id=65328d5a&scoped=true&"
import script from "./AdvisorMain.vue?vue&type=script&lang=js&"
export * from "./AdvisorMain.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorMain.vue?vue&type=style&index=0&id=65328d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65328d5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VFlex,VSpacer})
